/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Domain_Search_Modal_Search_DescInputs */

const en_domain_search_modal_search_desc = /** @type {(inputs: Domain_Search_Modal_Search_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search & claim a domain · under $15/yr included free`)
};

const es_domain_search_modal_search_desc = /** @type {(inputs: Domain_Search_Modal_Search_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar y reclamar un dominio · Menos de $15/año incluido gratis`)
};

const fr_domain_search_modal_search_desc = /** @type {(inputs: Domain_Search_Modal_Search_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher et réclamer un domaine · moins de 15 $/an inclus gratuitement`)
};

const de_domain_search_modal_search_desc = /** @type {(inputs: Domain_Search_Modal_Search_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain suchen & beanspruchen · unter 15 $/Jahr kostenlos enthalten`)
};

/** @type {(inputs: Domain_Search_Modal_Search_DescInputs) => LocalizedString} */
const ja_domain_search_modal_search_desc = en_domain_search_modal_search_desc;

/** @type {(inputs: Domain_Search_Modal_Search_DescInputs) => LocalizedString} */
const zh_domain_search_modal_search_desc = en_domain_search_modal_search_desc;

/** @type {(inputs: Domain_Search_Modal_Search_DescInputs) => LocalizedString} */
const ar_domain_search_modal_search_desc = en_domain_search_modal_search_desc;

/** @type {(inputs: Domain_Search_Modal_Search_DescInputs) => LocalizedString} */
const id_domain_search_modal_search_desc = en_domain_search_modal_search_desc;

/** @type {(inputs: Domain_Search_Modal_Search_DescInputs) => LocalizedString} */
const it_domain_search_modal_search_desc = en_domain_search_modal_search_desc;

/** @type {(inputs: Domain_Search_Modal_Search_DescInputs) => LocalizedString} */
const ru_domain_search_modal_search_desc = en_domain_search_modal_search_desc;

/** @type {(inputs: Domain_Search_Modal_Search_DescInputs) => LocalizedString} */
const pt_domain_search_modal_search_desc = en_domain_search_modal_search_desc;

/** @type {(inputs: Domain_Search_Modal_Search_DescInputs) => LocalizedString} */
const ko_domain_search_modal_search_desc = en_domain_search_modal_search_desc;

/**
* | output |
* | --- |
* | "Search & claim a domain · under $15/yr included free" |
*
* @param {Domain_Search_Modal_Search_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_search_modal_search_desc = /** @type {((inputs?: Domain_Search_Modal_Search_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Search_Modal_Search_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_search_modal_search_desc(inputs)
	if (locale === "es") return es_domain_search_modal_search_desc(inputs)
	if (locale === "fr") return fr_domain_search_modal_search_desc(inputs)
	if (locale === "de") return de_domain_search_modal_search_desc(inputs)
	if (locale === "ja") return ja_domain_search_modal_search_desc(inputs)
	if (locale === "zh") return zh_domain_search_modal_search_desc(inputs)
	if (locale === "ar") return ar_domain_search_modal_search_desc(inputs)
	if (locale === "id") return id_domain_search_modal_search_desc(inputs)
	if (locale === "it") return it_domain_search_modal_search_desc(inputs)
	if (locale === "ru") return ru_domain_search_modal_search_desc(inputs)
	if (locale === "pt") return pt_domain_search_modal_search_desc(inputs)
	return ko_domain_search_modal_search_desc(inputs)
});